
import jobsMixin from '~/mixins/jobs/jobsMixin'
import generalMixin from '~/mixins/generalMixin'

export default {
  mixins: [
    jobsMixin,
    generalMixin
  ],

  props: {
    item: {
      type: Object,
      default () {
        return {}
      },
      required: true
    }
  },

  data () {
    return {
      loading: false
    }
  },

  methods: {
    async jobFavClick (item, doFav = true) {
      this.loading = true

      const res = await this.apiJobFavoriteJob(item.juid, doFav)
      if (!res?.success) {
        this.$bvToast.toast(res.details ? res.details : (!!res.message ? res.message : res.exception), {
          title: this.$t('toast.header.error'),
          variant: 'danger',
          solid: true
        })
      } else {
        item.is_favorited = doFav
      }

      window.setTimeout(() => {
        this.loading = false
      }, 750)
    }
  }
}
